
































import { Component, Prop, Vue } from 'vue-property-decorator';

import UtilsService from '@/core/services/utils.service';

export enum FlatSelectorTextMultipleBorderBottom {
  Primary = 'bdr-bt--primary',
  Secondary = 'bdr-bt--secondary',
}

@Component({
  components: {},
})
export default class FlatSelectorTextMultiple extends Vue {
  @Prop() private options!: any[];
  @Prop() private initialOptions!: any[];
  @Prop({ default: () => ({}) }) private optionFields!: any;
  @Prop({ default: false }) private disabled!: boolean;
  @Prop({ default: false }) private allowSearch!: boolean;
  @Prop({
    default: FlatSelectorTextMultipleBorderBottom.Primary,
  })
  private borderBottom!: FlatSelectorTextMultipleBorderBottom;

  private selectedOptions: any = [];
  private showOptions: boolean = false;
  private showOptionsTimeout!: any;

  private created() {
    this.assignOptionSelected();
  }

  get selectOptions() {
    return UtilsService.parseToObject(this.optionFields, this.options);
  }

  get getBorderBottom() {
    let borderBottom = '';
    if (this.showOptions) {
      borderBottom = this.borderBottom;
    }
    return borderBottom;
  }

  get inputValue() {
    return this.selectedOptions.length === 0
      ? '-'
      : this.selectedOptions
          .map((thisOption: any) => {
            return thisOption.label;
          })
          .join(' ');
  }

  private assignOptionSelected() {
    this.selectedOptions = UtilsService.parseToObject(
      this.optionFields,
      this.initialOptions,
    );
  }

  private checkOptionSelected(option: any) {
    return (
      this.selectedOptions
        .map((thisOption: any) => {
          return thisOption.value;
        })
        .filter((value: string) => {
          return value === option.value;
        }).length > 0
    );
  }

  private setShowOptions(value: boolean) {
    if (this.disabled) {
      return false;
    }
    this.showOptionsTimeout = setTimeout(() => {
      this.showOptions = value;
    }, 500);
  }

  private changeOptionSelected(option: any) {
    if (this.checkOptionSelected(option)) {
      const index = this.selectedOptions
        .map((thisOption: any) => {
          return thisOption.value;
        })
        .indexOf(option.value);
      this.selectedOptions.splice(index, 1);
    } else {
      this.selectedOptions.push(option);
    }
    this.selectedOptions = this.selectedOptions.sort(
      (option1: any, option2: any) => {
        return option1.label > option2.label;
      },
    );
    this.$emit('input', this.selectedOptions);
  }

  private handleMouseleave() {
    if (!this.showOptions && this.showOptionsTimeout) {
      window.clearTimeout(this.showOptionsTimeout);
    }
    this.setShowOptions(false);
  }

  private handleClick(option: any) {
    this.changeOptionSelected(option);
  }
}
